<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skeleton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />
        <vs-input
          maxlength="11"
          v-model="phone"
          placeholder="شماره مشتری را وارد کنید ..."
          @keyup.enter="searchUser"
        />
        <div class="ml-2" v-show="phone !== ''">
          <vs-button
            @click="phone = ''"
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-x"
          ></vs-button>
        </div>
        <vs-button
          v-show="phone.length === 11"
          @click="searchUser"
          color="primary"
          class="ml-5"
          block
          >{{ "جستجو" }}</vs-button
        >
        <vs-spacer />
        <!-- <socket-status /> -->
        <profile-drop-down />
        <reload />
        <back />
      </vs-navbar>
    </div>

    <vs-popup :title="registerPopupCta" :active.sync="showRegisterPopup">
      <vs-col vs-w="6" vs-xs="12" class="mb-5">
        شماره همراه کاربر:
        <vs-input
          v-model="phone"
          placeholder="شماره همراه کاربر"
          class="w-100 mt-1"
        />
      </vs-col>
      <vs-col vs-w="6" vs-xs="12" class="mb-5">
        نام و نام خانوادگی کاربر:
        <vs-input
          v-model="userFullName"
          placeholder="نام و نام خانوادگی کاربر"
          class="w-100 mt-1"
        />
      </vs-col>

      <vs-col vs-w="12" class="mb-0 mt-5">
        <vs-button @click="registerUser" class="w-full" color="secondary">
          {{ registerPopupCta }}
        </vs-button>
      </vs-col>
    </vs-popup>

    <vs-popup title="تکمیل پروفایل" :active.sync="showUnregisterPopup">
      <vs-col vs-w="12" class="mb-6">
        <div class="flex items-center flex-col">
          <h2 class="font-bold">{{ phone }}</h2>
          <h5 class="mb-3">پروفایل مشتری در سیستم تکمیل نشده است.</h5>
          <p>
            میتوانید با زدن روی دکمه تکمیل پروفایل، اطلاعات مشتری خود را تکمیل
            کنید.
          </p>
        </div>
      </vs-col>

      <vs-col vs-w="6" class="mb-0">
        <vs-button
          @click="sendMenuLink"
          class="w-full"
          type="border"
          color="secondary"
          style="font-weight: 500"
          >ارسال لینک</vs-button
        >
      </vs-col>
      <vs-col vs-w="6" class="mb-0">
        <vs-button
          @click="handleOnClickRegister"
          class="w-full"
          color="secondary"
          >تکمیل پروفایل</vs-button
        >
      </vs-col>
    </vs-popup>

    <vs-popup title="" :active.sync="showNotFoundUserPopup">
      <vs-col vs-w="12" class="mb-6">
        <div class="flex items-center flex-col">
          <h3 class="mb-4 font-bold">کاربری با شماره {{ phone }} پیدا نشد.</h3>
          <p>در صورت ثبت‌نام، کاربر به باشگاه مشتریان شما افزوده خواهد شد.</p>
        </div>
      </vs-col>

      <vs-col vs-w="6" class="mb-0">
        <vs-button
          @click="sendMenuLink"
          class="w-full"
          type="border"
          color="secondary"
          style="font-weight: 500"
          >ارسال لینک</vs-button
        >
      </vs-col>
      <vs-col vs-w="6" class="mb-0">
        <vs-button
          @click="handleOnClickRegister"
          class="w-full"
          color="secondary"
          >ثبت‌نام کاربر</vs-button
        >
      </vs-col>
    </vs-popup>

    <vs-popup title="اطلاعات کاربر" :active.sync="showUserInfoPopup">
      <vs-col vs-w="12" class="mb-6" v-if="user">
        <div class="flex items-center flex-col">
          <h2 class="mb-2 font-bold">
            {{ user.name }}
          </h2>
          <h4 class="mb-3">{{ user.phone }}</h4>
          <p>میتوانید برای کاربر مورد نظر لینک فروشگاه خود را ارسال کنید.</p>
        </div>
      </vs-col>

      <vs-col vs-w="6" class="mb-0">
        <vs-button
          @click="sendMenuLink"
          class="w-full"
          type="border"
          color="secondary"
          style="font-weight: 500"
          >ارسال لینک</vs-button
        >
      </vs-col>
      <vs-col vs-w="6" class="mb-0" v-if="user">
        <vs-button
          @click="addCustomer"
          class="w-full success-button"
          :color="user.isCustomer ? 'success' : 'secondary'"
          :disabled="user.isCustomer"
        >
          {{ user.isCustomer ? "عضو شده" : "عضویت باشگاه مشتریان" }}
        </vs-button>
      </vs-col>
    </vs-popup>
  </div>
</template>

<script>
import ProfileDropDown from "./ProfileDropDown.vue";
import Back from "./Back.vue";
import Reload from "./Reload.vue";
import providerApiService from "../../../services/api/ProviderApiService";
import { mapGetters } from "vuex";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      phone: "",
      userFullName: "",
      user: null,
      showRegisterPopup: false,
      showUnregisterPopup: false,
      showNotFoundUserPopup: false,
      showUserInfoPopup: false,
    };
  },
  components: {
    ProfileDropDown,
    Back,
    Reload,
  },
  computed: {
    registerPopupCta() {
      return this.user?.id ? "تکمیل پروفایل" : "ثبت نام";
    },
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
        ? "#10163a"
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor != "#10163a" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor != "#fff" && this.$store.state.theme !== "dark"),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    classObj() {
      if (this.verticalNavMenuWidth == "default") {
        return "navbar-default";
      } else if (this.verticalNavMenuWidth == "reduced") {
        return "navbar-reduced";
      } else if (this.verticalNavMenuWidth) {
        return "navbar-full";
      }

      return "";
    },
  },
  methods: {
    searchUser() {
      this.user = null;

      this.$vs.loading();
      providerApiService
        .searchUser(this.currentProvider.id, this.phone)
        .then((result) => {
          if (result.data?.id) {
            this.user = {
              ...result.data,
              isCustomer: result.additional?.is_customer,
            };

            if (!this.user.name) {
              this.showUnregisterPopup = true;
            } else {
              this.showUserInfoPopup = true;
            }
          } else {
            this.showNotFoundUserPopup = true;
          }
        })
        .catch((err) => {
          this.$vs.notify({
            text: err.message?.message,
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => this.$vs.loading.close());
    },
    handleOnClickRegister() {
      this.showRegisterPopup = true;
      this.showNotFoundUserPopup = false;
      this.showUnregisterPopup = false;
    },
    registerUser() {
      if (this.userFullName) {
        this.user = {
          ...this.user,
          name: this.userFullName,
        };
      }

      if (this.phone) {
        this.user = {
          ...this.user,
          phone: this.phone,
        };
      }

      this.$vs.loading();
      providerApiService
        .registerUser(this.currentProvider.id, this.user)
        .then((result) => {
          this.user = {
            ...this.user,
            ...result.data,
            isCustomer: result.additional?.is_customer,
          };
          this.showUserInfoPopup = true;
          this.showRegisterPopup = false;
        })
        .finally(() => this.$vs.loading.close());
    },
    addCustomer() {
      this.$vs.loading();
      providerApiService
        .addCustomer(this.currentProvider.id, this.user.id)
        .then((result) => {
          this.$vs.notify({
            text: result.message,
            color: "success",
            position: "bottom-center",
          });
          this.showUserInfoPopup = false;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    sendMenuLink() {
      const message = `جهت ورود به منو / فروشگاه مجموعه ${
        this.currentProvider.name
      } بر روی لینک زیر کلیک کنید.\n${
        process.env.VUE_APP_MENU_LINK + this.currentProvider.username
      }`;
      this.$vs.loading();
      providerApiService
        .sendSms(
          this.currentProvider.id,
          message,
          this.user?.phone || this.phone
        )
        .then((result) => {
          this.$vs.notify({
            text: result.message,
            color: "success",
            position: "bottom-center",
          });
        })
        .catch((err) =>
          this.$vs.notify({
            text: err.getErrorDescriptions(),
            color: "danger",
            position: "bottom-center",
          })
        )
        .finally(() => {
          this.$vs.loading.close();
          this.showRegisterPopup = false;
          this.showUserInfoPopup = false;
          this.showUnregisterPopup = false;
          this.showNotFoundUserPopup = false;
        });
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
  },
};
</script>

<style scoped lang="scss">
.local-popup {
  .con-vs-popup .vs-popup {
    max-width: 400px !important;
  }
}

.success-button {
  &:disabled {
    opacity: 1;
  }
}
</style>
